import { useTranslation } from 'next-i18next';
import { useMarket } from '@bridebook/web/app-shared/lib/i18n/hooks/use-market';
import { useWeddingWebsite } from '@bridebook/web/lib/wedding-website/hooks/query';
import { getWeddingWebsiteId } from '@bridebook/web/lib/wedding-website/hooks/query/selectors';
import { env } from '@bridebook/web/lib/env';

export const useWeddingWebsiteUrl = (linkToRsvp?: boolean) => {
  const { t } = useTranslation('weddingWebsite');
  const market = useMarket();
  const isLive = env.LIVE;

  const origin = isLive
    ? 'https://bridebook.com'
    : typeof window !== 'undefined'
      ? window.location.origin
      : env.COUPLESIDE_URL;
  const host = isLive ? 'bridebook.com' : typeof window !== 'undefined' ? window.location.host : '';
  const basePath = `${market.prefix}/for`;
  const mainPath = `${host}/${basePath}`;

  const { data: websiteId } = useWeddingWebsite({
    select: getWeddingWebsiteId,
  });
  const websiteIdWithRsvp = websiteId && linkToRsvp ? `${websiteId}/rsvp` : websiteId;
  const secondaryPath = websiteIdWithRsvp || t('main.shareLink.linkPlaceholder');
  const websiteUrl = `${origin}/${basePath}/${secondaryPath}`;

  return { mainPath, secondaryPath, websiteId, websiteUrl };
};
